import React from "react";
import styled from "styled-components";
import Poster from "./Poster";
import Text from "../../../components/Text/Text";
import { Device } from "../../../components/device";
import { absoluteURL, relativeURL } from "../../../util/UrlHelper";
import { getPlaceholderImage } from "../../../util/MediaHelper";
import { ShowSearchResult } from "../../../typings/typings";

const ShowsGridWrap = styled.div`
    position: relative;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    ${Device.laptop} {
        margin-left: -1rem;
        margin-right: -1rem;
    }
`;

const ShowsGridItem = styled.div<ShowGridProps>`
    width: 100%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    ${Device.tablet} {
        width: 50%;
    }
    ${Device.tabletLandscape} {
        width: 33.33%;
    }
    ${Device.laptop} {
        padding-left: 1rem;
        padding-right: 1rem;
        width: ${(props) =>
            props.columns === 5 ? "20%" : props.columns === 4 ? "25%" : props.columns === 3 ? "33.33%" : props.columns === 2 ? "50%" : "100%"};
    }
`;

interface ShowGridProps {
    columns: number;
    shows: ShowSearchResult[];
    buyOnClick: (eventNo: number, showNo?: number) => void;
}

const ShowsGrid: React.FC<ShowGridProps> = (props) => (
    <ShowsGridWrap>
        {props.shows.map((show: ShowSearchResult, index) => {
            const { poster, venues, url, heading, name, events, previewTeaserText } = show;

            const setHeadingInnerHtml = () => {
                return {
                    __html: heading || "",
                };
            };

            // first or default event
            const event = events?.find((ev) => {
                return !!(ev?.showTimes && ev?.showTimes.length > 0);
            });
            const startDate = event?.startDate;
            const eventNo = event?.eventNo;
            const isSoldOut = event?.showTimes?.every((st) => st.isSoldOut);
            const purchaseUrls = event?.tixlyPurchaseUrls;

            return (
                <ShowsGridItem key={index} {...props}>
                    <Poster
                        image={absoluteURL(poster ? poster.umbracoFile?.src || poster._url : getPlaceholderImage(300, 400))}
                        imageAlt={name}
                        href={relativeURL(url)}
                        target="_self"
                        venues={venues}
                        date={startDate}
                        eventNo={eventNo}
                        isSoldOut={isSoldOut || false}
                        events={events}
                        buyOnClick={props.buyOnClick}
                        purchaseUrls={purchaseUrls}
                        previewTeaserText={previewTeaserText}
                    >
                        {heading ? (
                            <Text>
                                <h4 className="uppercase" dangerouslySetInnerHTML={setHeadingInnerHtml()}></h4>
                            </Text>
                        ) : null}
                    </Poster>
                </ShowsGridItem>
            );
        })}
    </ShowsGridWrap>
);

export default ShowsGrid;
